module.exports = __webpack_public_path__ + "static/media/591ad449-3daa-4e79-a4c8-1e4465e918a0-ojIzhbCI6tHiBX6KtHljTgzTxo25JY.4373ebba.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/591ad449-3daa-4e79-a4c8-1e4465e918a0-ojIzhbCI6tHiBX6KtHljTgzTxo25JY.webp
// module id = 623
// module chunks = 0